import "./src/assets/styles/global.css";
import React from "react";

// Don't export onRenderBody directly as onClientEntry
// Instead, implement the scripts for client-side navigation differently
export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    // GTM script
    const gtmScript = document.createElement("script");
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5FHZF4R4');`;
    document.head.appendChild(gtmScript);

    // GA script
    const gaScript = document.createElement("script");
    gaScript.async = true;
    gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-M4HF3B83D0";
    document.head.appendChild(gaScript);

    // GA config script
    const gaConfigScript = document.createElement("script");
    gaConfigScript.innerHTML = `
      window.dataLayer = window.dataLayer || []; 
      function gtag(){dataLayer.push(arguments);} 
      gtag('js', new Date()); 
      gtag('config', 'G-M4HF3B83D0');
    `;
    document.head.appendChild(gaConfigScript);

    // GTM noscript iframe
    const noscriptContainer = document.createElement("noscript");
    const gtmIframe = document.createElement("iframe");
    gtmIframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-5FHZF4R4";
    gtmIframe.height = "0";
    gtmIframe.width = "0";
    gtmIframe.style.display = "none";
    gtmIframe.style.visibility = "hidden";
    noscriptContainer.appendChild(gtmIframe);
    document.body.insertBefore(noscriptContainer, document.body.firstChild);
  }
};
